import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

const checkIcon = require("./../assets/img/check-icon2.svg").default;

const PaymentSuccess = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { langJson } = useLanguage();
  const [isFinalizing, setIsFinalizing] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const finalizePaypalOrder = async () => {
      if (!location?.state?.finalizeOrder || !location?.state?.orderPayload) return;
      if (!user?.authorisation?.token) return;

      setIsFinalizing(true);
      try {
        const response = await fetch(`${API_BASE_URL}order`, {
          method: "POST",
          body: JSON.stringify(location.state.orderPayload),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });

        const responseData = await response.json();
        if (!responseData?.res) {
          navigate("/payment-failed", { state: { message: responseData?.msg || langJson?.paymentfailed || "Payment failed" } });
          return;
        }

        sessionStorage.removeItem("FFFShippingId");
        sessionStorage.removeItem("FFFStoreId");
      } catch (error) {
        navigate("/payment-failed", { state: { message: langJson?.paymentfailed || "Payment failed" } });
      } finally {
        if (isMounted) {
          setIsFinalizing(false);
        }
      }
    };

    finalizePaypalOrder();

    return () => {
      isMounted = false;
    };
  }, [location?.state, user, navigate, langJson?.paymentfailed]);

  return (
    <div>
      <Header />
      <style>{`body { background: #F5F7FA; }`}</style>

      <div className="mainDiv">
        <div className="orderDiv">
          <img src={checkIcon} alt="" />
          <h2>{langJson?.orderplaced}</h2>
          {isFinalizing ? <p>{langJson?.pleasewait || "Please wait..."}</p> : null}
          <p>
            {langJson?.yourorderwasplacedsuccessfullyformoredetailscheck}
            <Link to=""> “{langJson?.myorders}”</Link>
          </p>
          <div className="orderBtns">
            <Link to="/my-orders" className="myOrderBtn">
              {langJson?.myorder}
            </Link>
            <Link to="/shop" className="contBtn">
              {langJson?.continueshopping}
            </Link>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PaymentSuccess;
